class BrappContestParticipation extends HTMLElement {
  connectedCallback() {
    this.participationInput = this.querySelector('[data-brapp-participation]');
    this.rulesPanel = this.querySelector('[data-brapp-rules-panel]');
    this.rulesInput = this.querySelector('[data-brapp-rules]');

    if (!this.participationInput || !this.rulesPanel || !this.rulesInput) return;

    this.participationInput.addEventListener('change', () => this.sync());
    this.sync();
  }

  sync() {
    const isParticipating = this.participationInput.checked;

    this.participationInput.setAttribute('aria-expanded', String(isParticipating));
    this.rulesPanel.hidden = !isParticipating;
    this.rulesInput.disabled = !isParticipating;
    this.rulesInput.required = isParticipating;

    if (!isParticipating) {
      this.rulesInput.checked = false;
      this.rulesInput.setCustomValidity('');
    }
  }
}

if (!customElements.get('brapp-contest-participation')) {
  customElements.define('brapp-contest-participation', BrappContestParticipation);
}
